module.exports = __webpack_public_path__ + "static/media/inversion-global.caa23574.png";